import { render, staticRenderFns } from "./WpHistoryCommentHeading.vue?vue&type=template&id=62609765&scoped=true&"
import script from "./WpHistoryCommentHeading.vue?vue&type=script&lang=js&"
export * from "./WpHistoryCommentHeading.vue?vue&type=script&lang=js&"
import style0 from "./WpHistoryCommentHeading.vue?vue&type=style&index=0&id=62609765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62609765",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62609765')) {
      api.createRecord('62609765', component.options)
    } else {
      api.reload('62609765', component.options)
    }
    module.hot.accept("./WpHistoryCommentHeading.vue?vue&type=template&id=62609765&scoped=true&", function () {
      api.rerender('62609765', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WpHistoryCommentHeading.vue"
export default component.exports